import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { seleccionarPagina } from "../../../features/ui/uiSlice";
import { RootState } from "../../../store";
import { useVerCobranzaPolizaQuery } from "../../../services/docs";
import { Spinner } from "../../../components/Spinner";
import { TablaCobranzaPolizaComponent } from "../../../components/TablaCobranzaPolizaComponent";

export const CobranzaScreen = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(seleccionarPagina("p-cobranza"));
  }, [0]);
  const { seleccion, p_seleccion } = useSelector(
    (state: RootState) => state.ui
  );
  const { data, isLoading } = useVerCobranzaPolizaQuery(seleccion);
  if (isLoading) {
    return (
      <div className="flex w-full justify-center">
        <Spinner />
      </div>
    );
  }
  if (!isLoading && data && data.cobranza.length === 0) {
    return (
      <div className="w-full">
        <h1 className="mb-5 rounded-t-xl border-b-2 border-primary py-2 pl-3 text-primary">
          Cobranza
        </h1>
        <div className="w-full rounded-xl bg-primary py-2 text-center text-white">
          No se encontró información de cobranza
        </div>
      </div>
    );
  }
  if (!isLoading && data && data.cobranza.length > 0) {
    return <TablaCobranzaPolizaComponent data={data.cobranza} />;
  }
};
